import helpersNumbers from "../helpers/numbers";
export default {
  AMOUNT_IS_LESS: ` حداقل مبلغ   ${helpersNumbers.toPersianNum(
    helpersNumbers.toFormatFinanceNumber(
      process.env.REACT_APP_AT_LEAST_AMOUNT_CHARGE
    )
  )} تومان می باشد. `,
  MAX_AMOUNT_IS_LOWER_THAN_MIN_AMOUNT: "حداکثر مبلغ کمتر از حداقل مبلغ است.",
};
